import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Sale Consultants
      {record ? `: ${record.full_name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/SalesAdvisor/Title.js